module.exports = __webpack_public_path__ + "fonts/Kent4FPrinted.7a78afb.woff2";